module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-zone-cost"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink pl-0"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('ZoneConfigButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ZC" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Z" + _vm._s(_vm.item.zone.id) + " " + _vm._s(_vm.item.zone.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Cost on Start")]), (_vm.item.common_cost_start) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("CC" + _vm._s(_vm.item.common_cost_start.id) + " " + _vm._s(_vm.item.common_cost_start.reason))]) : _vm._e()]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Cost on End")]), (_vm.item.common_cost_end) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("CC" + _vm._s(_vm.item.common_cost_end.id) + " " + _vm._s(_vm.item.common_cost_end.reason))]) : _vm._e()]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "fiel-value"
  }, [_vm._v(_vm._s(_vm.item.type))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Max vehicles")]), _c('div', {
    staticClass: "fiel-value"
  }, [_vm._v(_vm._s(_vm.item.max_vehicles))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Min fuel level")]), _c('div', {
    staticClass: "fiel-value"
  }, [_vm._v(_vm._s(_vm.item.min_fuel_level))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Max speed")]), _c('div', {
    staticClass: "fiel-value"
  }, [_vm._v(_vm._s(_vm.item.max_speed))])]), _c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-zone-config',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a371576!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ZoneConfig.vue
// module id = 2415
// module chunks = 1